import { useEffect, useState } from "react"
import { useMobileOs } from "@/components/hooks/useIsIos"

type OneLinkUrlConfig = {
  afWebDp: string
  deepLinkValue: string
  pageName: string
  repushOnMount?: boolean
  defaultURL: string
}

export const useSmartScriptUrl = (
  oneLinkKey: string,
  config: OneLinkUrlConfig
) => {
  const {
    afWebDp,
    deepLinkValue,
    pageName,
    repushOnMount = false,
    defaultURL,
  } = config || {}
  const mobileOs = useMobileOs()
  const isMobileDevice = mobileOs === "ios" || mobileOs === "android"

  const initialUrl = isMobileDevice ? defaultURL : afWebDp
  const [oneLinkUrl, setOneLinkUrl] = useState(initialUrl)
  const [resolved, setResolved] = useState(false)

  //this hooks is used to generate gtmData, allow GTM injected script to fetch and save it to window object
  useEffect(() => {
    if (typeof window === "undefined") return

    // already computed previously, skip re-push
    if (!repushOnMount && window[oneLinkKey as any]) return

    const gtmData = {
      event: "cta_click",
      cta_type: "smart_script",
      af_web_dp: encodeURIComponent(afWebDp || "") || "",
      deep_link_value: encodeURIComponent(deepLinkValue || "") || "",
      page_name: encodeURIComponent(pageName || "") || "",
      oneLinkKey,
    }

    if (!window.dataLayer) {
      window.dataLayer = []
    }
    window.dataLayer.push(gtmData)
  }, [oneLinkKey, afWebDp, deepLinkValue, pageName, repushOnMount])

  //this hooks is used to fetch GTM injected data from window object
  useEffect(() => {
    if (typeof window === "undefined") return

    const assign = (url: string | undefined | null) => {
      if (!url) return
      setResolved(true)
      setOneLinkUrl(url)
    }

    assign((window as any)[oneLinkKey])
    if (!resolved) {
      const ns = (window as any).__onelinks
      if (ns && typeof ns === "object") assign(ns[oneLinkKey])
    }

    // Listen to GTM tag completion
    const onReady = (e: Event) => {
      const detail = (e as CustomEvent).detail || {}
      if (detail.key === oneLinkKey) assign(detail.url)
    }
    window.addEventListener("onelink:ready", onReady)

    return () => {
      window.removeEventListener("onelink:ready", onReady)
    }
  }, [oneLinkKey, resolved])

  return { oneLinkUrl }
}
